module.exports = __webpack_public_path__ + "img/trolley.f0691ed9.svg";